import * as React from "react";
import { Label } from "components/ui/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "components/ui/select";

type Props = {
  label?: string;
  value?: string;
  onChange?: (value: string | undefined) => void;
  placeholder?: string;
  disabled?: boolean;
  className?: string;
};

const OPTIONS = [
  { value: "E", label: "Entrada" },
  { value: "S", label: "Saída" },
];

export default function InputEntryExitType({
  label = "Entrada/Saída",
  value,
  onChange,
  placeholder = "Selecionar (Entrada/Saída)",
  disabled,
  className,
}: Props) {
  const id = React.useId();

  return (
    <div className={`flex flex-col gap-2 ${className || ""}`}>
      {label && (
        <Label htmlFor={id} className="block text-sm font-medium text-gray-700">
          {label}
        </Label>
      )}

      <Select value={value} onValueChange={(v) => onChange?.(v)} disabled={disabled}>
        <SelectTrigger
          id={id}
          className="flex items-center w-full h-8 px-3 border rounded-md text-left text-sm text-gray-700"
        >
          <SelectValue placeholder={placeholder} />
        </SelectTrigger>

        <SelectContent className="w-[--radix-select-trigger-width]">
          {OPTIONS.map((opt) => (
            <SelectItem key={opt.value} value={opt.value} className="text-gray-700">
              {opt.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
